// extracted by mini-css-extract-plugin
export default {"root":"checkbox-default-theme-large__root","checkmark":"checkbox-default-theme-large__checkmark","error":"checkbox-default-theme-large__error"};